<template>
	<section>
		<h3 class="my-3">Medidas</h3>
		<v-layout wrap>
			<v-flex md6 xs12>
				<v-text-field
					type="number"
					v-model="form.quantity"
					background-color="white"
					box
					label="Quantidade"
					v-validate="{ required: true }"
					data-vv-name="Quantidade"
					:error-messages="errors.collect('Quantidade')"/>
			</v-flex>
			<v-flex md6 xs12>
				<v-autocomplete
					v-model="form.unitOfMeasurementSymbol"
					background-color="white"
					:items="unitsOfMeasurementItems"
					label="Unidade de medida"
					box
					clearable
					v-validate="{ required: true }"
					:error-messages="errors.collect('Unidade de medida')"
					data-vv-name="Unidade de medida"
					item-value="symbol"
					item-text="name"/>
			</v-flex>
			<v-flex lg4 md6 xs12>
				<v-text-field
					type="number"
					v-model="form.height"
					background-color="white"
					box
					label="Altura (mm)"
					data-vv-name="Altura"
					v-validate="{ required: false }"
					:error-messages="errors.first('Altura')"/>
			</v-flex>
			<v-flex lg4 md6 xs12>
				<v-text-field
					type="number"
					v-model="form.width"
					background-color="white"
					box
					label="Largura (mm)"
					data-vv-name="Largura"
					v-validate="{ required: false }"
					:error-messages="errors.collect('Largura')"/>
			</v-flex>
			<v-flex lg4 md6 xs12>
				<v-text-field
					type="number"
					v-model="form.length"
					background-color="white"
					box
					label="Comprimento (mm)"
					data-vv-name="Comprimento"
					v-validate="{ required: false }"
					:error-messages="errors.collect('Comprimento')"/>
			</v-flex>
			<v-flex md6 xs12>
				<v-text-field
					type="number"
					v-model="form.grossWeight"
					background-color="white"
					box
					label="Peso bruto (g)"
					data-vv-name="Peso bruto"
					v-validate="{ required: false }"
					:error-messages="errors.collect('Peso bruto')"/>
			</v-flex>
			<v-flex md6 xs12>
				<v-text-field
					type="number"
					v-model="form.netWeight"
					background-color="white"
					box
					label="Peso neto (g)"
					data-vv-name="Peso neto"
					v-validate="{ required: false }"
					:error-messages="errors.collect('Peso neto')"/>
			</v-flex>
		</v-layout>
	</section>
</template>

<script>
export default {
	name: 'NewProductStepItemMeasurement',
	inject: ['$validator'],
	props: {
		form: {
			required: true,
			type: Object
		},
		unitsOfMeasurement: {
			required: true,
			type: Array
		}
	},
	computed: {
		unitsOfMeasurementItems() {
			return this.unitsOfMeasurement.map(item => ({
				symbol: item.symbol,
				name: `[${item.symbol}] - ${item.name}`
			}));
		}
	}
};
</script>

<style lang="scss" scoped>
</style>
